import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroupDirective, UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { ToastService } from "@dffedb/ui";
import { Rolle } from "@e-forsyning/common/bruger";

import { LoginoplysningerSandbox } from "./loginoplysninger.sandbox";
import { LoginoplysningerViewModel } from "./model/loginoplysninger.view-model";

@Component({
    selector: "e-forsyning-loginoplysninger",
    templateUrl: "./loginoplysninger.component.html"
})
export class LoginoplysningerComponent implements OnInit {
    public vm$: Observable<LoginoplysningerViewModel>;
    public ejendomsadministrator: Rolle = Rolle.Ejendomsadministrator;

    @ViewChild(FormGroupDirective)
    public formGroupDirective: FormGroupDirective;

    constructor(private readonly sandbox: LoginoplysningerSandbox, private readonly toastService: ToastService) {}

    public ngOnInit(): void {
        this.hentData();
    }

    public async redigerMail(formGroup: UntypedFormGroup): Promise<any> {
        try {
            formGroup.controls["mail"].disable();
            await this.sandbox.redigerMail(formGroup.controls["mail"].value.toLowerCase());
            this.hentData();
        } catch (e) {
            this.toastService.visFejl(e.friendlyMessage);
        }
    }

    public annullerRedigerMail(formGroup: UntypedFormGroup, mail: string): void {
        formGroup.controls["mail"].setValue(mail);
        formGroup.controls["mail"].disable();
    }

    public async redigerLoginoplysninger(formGroup: UntypedFormGroup): Promise<void> {
        try {
            await this.sandbox.redigerLoginoplysninger(formGroup.value);
            this.toastService.visInfo("Dit kodeord er nu ændret.");
            this.formGroupDirective.resetForm();
            this.hentData();
        } catch (e) {
            this.toastService.visFejl(e.friendlyMessage);
        }
    }

    private hentData(): void {
        this.vm$ = this.sandbox.hentViewModel().pipe(shareReplay(1));
    }

    public addFocus(id: string): void {
        if (document.getElementById(id) === null) return;
        document.getElementById(id).focus();
    }
}
